exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-normal[data-v-eed220f0] {border: 1px solid #d9d9d9}\n.border-error[data-v-eed220f0] {border: 1px solid red}\n", ""]);

// exports
